export const CLOUD_MAX_RANGE = Math.pow(2, 21);
export const DATA_DEPTH = 7;
